module.exports = __webpack_public_path__ + "static/media/保腎護心網layout物件V3_13.0dd70eda.png";